import { GAME_KEYS } from "../game/game.constants"

export const VOD_TYPE = {
  CONTENTFUL_ENTRY: "CONTENTFUL ENTRY",
}

export const GAME_VOD_EXTENSION = {
  [GAME_KEYS.LEAGUE_OF_LEGENDS]: ["rofl"],
  [GAME_KEYS.FORTNITE]: ["replay"],
}

export const FILE_TYPE = {
  QUICKTIME: "video/quicktime",
  MP4: "video/mp4",
  ROFL: "rofl",
  REPLAY: "replay",
}

export const SUPPORTED_FILE_TYPE = [FILE_TYPE.QUICKTIME, FILE_TYPE.MP4]
export const SUPPORTED_FILE_EXTENSIONS = ["mov", "mp4"]

export const UPLOADING_STEP = {
  READY_TO_UPLOAD: "READY_TO_UPLOAD",
  UPLOADING: "UPLOADING",
  UPLOADED: "UPLOADED",
}

export const MAX_FILE_SIZE = 20 * 1024 * 1024 * 1024 // 20GiB

export const GAME_RECORD_HINTS_TITLE = gameKey => {
  switch (gameKey) {
    case GAME_KEYS.LEAGUE_OF_LEGENDS:
    case GAME_KEYS.FORTNITE:
    case GAME_KEYS.OVERWATCH:
    case GAME_KEYS.DOTA2:
      return "How to find your replay on the computer"
    case GAME_KEYS.TEAMFIGHT_TACTICS:
    case GAME_KEYS.CSGO:
    case GAME_KEYS.SSBU:
    case GAME_KEYS.WOW:
    case GAME_KEYS.HEARTHSTONE:
    case GAME_KEYS.MTG:
    case GAME_KEYS.VALORANT:
      return "How to record your gameplay on the computer"
    default:
      return "How to record your gameplay on the computer"
  }
}

export const GAME_RECORD_HINTS = gameKey => {
  switch (gameKey) {
    case GAME_KEYS.LEAGUE_OF_LEGENDS:
      return leagueRecordHints
    case GAME_KEYS.FORTNITE:
      return fortniteRecordHints
    case GAME_KEYS.OVERWATCH:
      return overwatchRecordHints
    case GAME_KEYS.DOTA2:
      return dota2RecordHints
    default:
      return generalRecordHints
  }
}

const leagueRecordHints = [
  "1. Open your Replays folder, replays are stored in \"C:\\Users\\[user]\\Documents\\League of Legends\\Replays\".",
  "2. The easiest way to share a particular replay is to delete any .rofl files that are in the folder. Once that's done, you can download the replay you want to share via the button in your match history.",
  "3. Once the download is complete you will then have a new file in the replays folder.",
  "4. Upload the new file here to get your Pro Video Review.",
  "Note: Do not upload a .rofl file from an outdated patch. Pros can only view replays from the current patch.",
]

const fortniteRecordHints = [
  "1. Launch Fortnite then open your Fortnite Career.",
  "2. Select \"Replays\".",
  "3. Choose and select the replay you want to share.",
  "4. Click on \"Rename and Save\" then rename the replay to \"proguides\".",
  "5. Click on \"Open Replay Folder\".",
  "6. Fortnite will then open a folder and you will be able to upload the file named \"proguides.replay\" here.",
]

const overwatchRecordHints = [
  "1. Launch Overwatch",
  "2. Go into \"Career Profile\"",
  "3. Head into the \"Replay\" Section",
  "4. Select the match you want reviewed.",
  "5. Click the share button, then copy and paste the code here.",
]

const dota2RecordHints = [
  "1. Launch DOTA 2.",
  "2. Go to your \"Profile\" and click on \"Recent Matches\".",
  "3. Click on a match to see an Overview.",
  "4. Find the Match ID at the bottom of the interface.",
  "5. Copy and paste the Match ID here.",
]

const generalRecordHints = [
  "To record your gameplay, use a screen recording software like Windows Screen Recorder or OBS to capture your video file.",
]

export const LOCAL_STORAGE_GPA_CHECKOUT_FIELDS = {
  USING_REPLAY_CODE: "using-replay-code",
  REPLAY_CODE: "replay-code",
  REPLAY_METADATA: "replay-metadata",
  VIDEO_URL: "video-url",
  VIDEO_METADATA: "video-metadata",
  COMMENTS: "comments",
  GAME: "game",
  PLAYER_NAME: "player-name",
  CHAMPION: "champion",
  OFFER_AMOUNT: "offer-amount",
  COACH: "coach",
}

export const LOCAL_STORAGE_GPA_CHECKOUT_KEYS = {
  [LOCAL_STORAGE_GPA_CHECKOUT_FIELDS.USING_REPLAY_CODE]: "gpaCheckoutSessionUsingReplayCode",
  [LOCAL_STORAGE_GPA_CHECKOUT_FIELDS.REPLAY_CODE]: "gpaCheckoutSessionReplayCode",
  [LOCAL_STORAGE_GPA_CHECKOUT_FIELDS.REPLAY_METADATA]: "gpaCheckoutSessionReplayMeta",
  [LOCAL_STORAGE_GPA_CHECKOUT_FIELDS.VIDEO_URL]: "gpaCheckoutSessionVideoUrl",
  [LOCAL_STORAGE_GPA_CHECKOUT_FIELDS.VIDEO_METADATA]: "gpaCheckoutSessionVideoMeta",
  [LOCAL_STORAGE_GPA_CHECKOUT_FIELDS.COMMENTS]: "gpaCheckoutSessionComments",
  [LOCAL_STORAGE_GPA_CHECKOUT_FIELDS.GAME]: "gpaCheckoutSessionGame",
  [LOCAL_STORAGE_GPA_CHECKOUT_FIELDS.PLAYER_NAME]: "gpaCheckoutSessionPlayerName",
  [LOCAL_STORAGE_GPA_CHECKOUT_FIELDS.CHAMPION]: "gpaCheckoutSessionChampion",
  [LOCAL_STORAGE_GPA_CHECKOUT_FIELDS.OFFER_AMOUNT]: "gpaCheckoutSessionOfferAmount",
  [LOCAL_STORAGE_GPA_CHECKOUT_FIELDS.COACH]: "gpaCheckoutSessionCoach",
}



// WEBPACK FOOTER //
// ./src/store/vod/vod.constants.js